// extracted by mini-css-extract-plugin
module.exports = {"container":"MyPropsList_container__15FeC","skeleton-anim":"MyPropsList_skeleton-anim__30doD","fadeIn1":"MyPropsList_fadeIn1__1-mn-"};